import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { productCraft } from '../models/product-craft.model';

@Injectable({
  providedIn: 'root'
})
export class ProductCraftService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  createProductCraft(productCraft: productCraft): Observable<unknown> {
    return this.#http.postData(`${this.baseUrl}/ProductCraft`, { showLoader: true, showMessage: true }, productCraft);
  }

  readProductCrafts(): Observable<productCraft[]> {
    return this.#http.getData(`${this.baseUrl}/ProductCraft`, { showLoader: true, showMessage: false });
  }

  readProductCraftsbyId(id: string): Observable<productCraft> {
    return this.#http.getData(`${this.baseUrl}/ProductCraft/${id}`, { showLoader: true, showMessage: false });
  }

  readProductCraftByProductId(productId: string): Observable<productCraft[]> {
    return this.#http.getData(`${this.baseUrl}/ProductCraft/product/${productId}`, {
      showLoader: true,
      showMessage: false
    });
  }

  deleteProductCraft(productCraftId: string): Observable<unknown> {
    return this.#http.deleteData(`${this.baseUrl}/ProductCraft/${productCraftId}`, {
      showLoader: true,
      showMessage: true
    });
  }

  updateProductCraft(productCraft: productCraft): Observable<unknown> {
    return this.#http.putData(`${this.baseUrl}/ProductCraft/${productCraft.id}`, productCraft, {
      showLoader: true,
      showMessage: true
    });
  }
}
